export default __webpack_public_path__ + "static/media/windows.4f3cdc2f.mp4";